import type { Metaobject } from "@shopify/hydrogen-react/storefront-api-types";
import { useQuery } from "react-query";
import { client } from "./client";

const METAOBJECT_QUERY = `#graphql
query getMetaobject($id: ID!) {
  metaobject(id: $id) {
    id
    handle
    type
    fields {
      key
      value
    }
  }
}`;

type MetaobjectResp = Pick<Metaobject, "id" | "handle" | "type"> & {
  fields: {
    key: string;
    value: string;
  }[];
};

const getMetaobject = (id: string) =>
  client.query<{ metaobject?: MetaobjectResp }>(METAOBJECT_QUERY, { id });

const useMetaobjectQuery = (id: string) =>
  useQuery(["metaobject", id], () => getMetaobject(id), {
    select: (data) => data.metaobject,
  });

export { useMetaobjectQuery };
